//
// Small info button and popup, with information message
//
import PropTypes from 'prop-types';
import { useState } from 'react';

import FullPopup from './FullPopup';

const TextPopup = function TextPopup(props) {
  const {
    text,
    children,
    className,
  } = props;
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState(undefined);

  const togglePopup = (event) => {
    // console.log(`TextPopup click at x=${event?.clientX} y=${event?.clientY}`);

    setOpen((prev) => (!prev));

    if (event && event.clientX) {
      setPosition({
        x: event?.clientX,
        y: event?.clientY,
      });
    } else setPosition(undefined);
  };

  return (
    <>
      <button
        type="button"
        onClick={togglePopup}
        className={className}
      >
        {text}
      </button>

      {(open)
        ? (
            <FullPopup
              onClose={togglePopup}
              titleBar={false}
              className="max-w-[550px]"
              contentClassName="flex flex-col gap-2 items-stretch justify-center bg-pxCaseHeaderSecondaryBg italic text-justify"
              customSize
              // dark={false}
              position={position}
            >
              {children}
            </FullPopup>
          )
        : null}
    </>
  );
};

TextPopup.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default TextPopup;
